import React, { FC, useCallback, useState } from 'react';
import { Stack, Typography, IconButton, Button } from '@mui/material';
import { Icon } from '@iconify/react';
import '../../styles/multiplevinscontainer.css';

interface IProps {
  filteredVins: [];
  setFilteredVins: any;
  setInputText: (text: any) => void;
  // onSearch: (searchText: string) => void;
}

const MultipleVinsContainer: FC<IProps> = ({ filteredVins, setFilteredVins, setInputText }) => {
  const [viewAll, setViewAll] = useState(false);
  const vinsLength = filteredVins?.length;
  const removeVin = (index: number) => {
    const updatedTexts = [...filteredVins];
    updatedTexts.splice(index, 1);
    setInputText(updatedTexts);
    setFilteredVins(updatedTexts);
    // onSearch(updatedTexts.join(' '));
  };

  const viewLessVins = (
    <Stack direction="row" gap={1} height="fit-content" alignItems="center" mb={0} flexWrap="wrap" p={1.5}>
      <Typography
        sx={{
          width: '100%',
          color: '#1B1B1B',
          lineHeight: '15.6px',
          fontSize: '12px',
          fontWeight: '400',
          height: '16px',
          paddingTop: '8px',
        }}
      >
        Multiple keyword search is available for Batch Number and VIN search only:
      </Typography>
      {filteredVins?.slice(0, 19)?.map((item: any, index) => {
        return (
          item?.length > 0 && (
            <Stack
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              direction="row"
              alignItems="center"
              gap={1}
              borderRadius={1}
              px={0.75}
              // pl={1.25}
              py={0.75}
              pr={1.25}
              bgcolor="#6B787F"
            >
              <Typography
                variant="caption"
                lineHeight="130%"
                height="fit-content"
                className="multiple-vin-text"
                color="#fff"
              >
                {item}
              </Typography>
              <IconButton size="medium" className="multiple-vin-icon" onClick={() => removeVin(index)}>
                <Icon icon="eva:close-outline" fontSize={20} color="#fff" />
              </IconButton>
            </Stack>
          )
        );
      })}
      {vinsLength >= 20 && (
        <Button
          variant="text"
          onClick={() => {
            setViewAll(true);
          }}
        >
          <Typography variant="caption" lineHeight="130%" height="fit-content" pr={0.75}>
            View All {vinsLength} keywords
          </Typography>
          <IconButton size="medium" className="multiple-vin-icon">
            <Icon icon="ep:arrow-down" color="#456bd9" fontSize={14} />
          </IconButton>
        </Button>
      )}
    </Stack>
  );

  const allVinsModal = () => {
    return (
      <Stack
        px={2.5}
        pl={3}
        py={2.5}
        pr={3}
        gap={1.25}
        ml={3}
        mr={2}
        sx={{
          zIndex: 1,
          position: 'fixed',
          backgroundColor: '#FFFFFF',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
          borderRadius: '4px',
        }}
      >
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" gap={1.25} alignContent="center">
            <Typography
              variant="caption"
              height="fit-content"
              className="multiple-vin-text"
              color="#1B1B1B"
              fontSize="12px"
              fontWeight={400}
              lineHeight="15.6px"
            >
              Total Keywords : {vinsLength}
            </Typography>
            <Typography
              variant="caption"
              height="fit-content"
              color="#456BD9"
              fontSize="14px"
              fontWeight={400}
              lineHeight="18.2px"
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                setInputText('');
                setFilteredVins([]);
                // onSearch('');
                setViewAll(false);
              }}
            >
              Remove All
            </Typography>
          </Stack>
          <IconButton size="large" className="multiple-vin-icon" onClick={() => setViewAll(false)}>
            <Icon icon="eva:close-outline" fontSize={24} />
          </IconButton>
        </Stack>
        <Stack
          direction="row"
          gap={1}
          height="fit-content"
          alignItems="center"
          mb={1}
          flexWrap="wrap"
          sx={{ maxHeight: '84px', overflow: 'auto' }}
        >
          {filteredVins.map((item, index) => (
            <Stack
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              direction="row"
              alignItems="center"
              gap={1}
              borderRadius={1}
              px={0.75}
              pl={1.25}
              py={0.75}
              pr={1.25}
              bgcolor="#6B787F"
            >
              <Typography
                variant="caption"
                lineHeight="130%"
                height="fit-content"
                className="multiple-vin-text"
                color="#fff"
              >
                {item}
              </Typography>
              <IconButton size="medium" className="multiple-vin-icon" onClick={() => removeVin(index)}>
                <Icon icon="eva:close-outline" fontSize={20} color="#fff" />
              </IconButton>
            </Stack>
          ))}
        </Stack>
      </Stack>
    );
  };

  return viewAll === false ? viewLessVins : allVinsModal();
};

export default MultipleVinsContainer;
